export function getElementById(id: string): HTMLElement | null {
    return document.getElementById(id)
}
